module.exports = __webpack_public_path__ + "static/media/stanford.0bfa932b.jpg";